import { render, staticRenderFns } from "./SummaryStatistics.vue?vue&type=template&id=b3395e94&scoped=true"
import script from "./SummaryStatistics.vue?vue&type=script&lang=ts"
export * from "./SummaryStatistics.vue?vue&type=script&lang=ts"
import style0 from "./SummaryStatistics.vue?vue&type=style&index=0&id=b3395e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3395e94",
  null
  
)

export default component.exports